var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useId } from 'react';
import classNames from 'classnames';
import { Collapse } from '@sb1/ffe-collapse-react';
import { Icon } from '@sb1/ffe-icons-react';
export var Tooltip = React.forwardRef(function (_a, ref) {
    var initialIsOpen = _a.isOpen, ariaControls = _a["aria-controls"], _b = _a["aria-label"], ariaLabel = _b === void 0 ? 'Vis hjelpetekst' : _b, children = _a.children, className = _a.className, onClick = _a.onClick, tabIndex = _a.tabIndex, containerProps = _a.containerProps;
    var tooltipButtonId = useId();
    var tooltipId = useId();
    var _c = useState(!!initialIsOpen), isOpen = _c[0], setIsOpen = _c[1];
    var handleClick = function (evt) {
        setIsOpen(function (prev) { return !prev; });
        if (onClick) {
            onClick(evt);
        }
    };
    var helpIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIj48cGF0aCBkPSJNNDgwLTI0MHEyMCAwIDM0LTE0dDE0LTM0cTAtMjAtMTQtMzR0LTM0LTE0cS0yMCAwLTM0IDE0dC0xNCAzNHEwIDIwIDE0IDM0dDM0IDE0Wm0tMzYtMTUzaDczcTAtMzcgNi41LTUyLjVUNTU1LTQ4NXEzNS0zNCA0OC41LTU4dDEzLjUtNTNxMC01NS0zNy41LTg5LjVUNDg0LTcyMHEtNTEgMC04OC41IDI3VDM0My02MjBsNjUgMjdxOS0yOCAyOC41LTQzLjVUNDgyLTY1MnEyOCAwIDQ2IDE2dDE4IDQycTAgMjMtMTUuNSA0MVQ0OTYtNTE4cS0zNSAzMi00My41IDUyLjVUNDQ0LTM5M1ptMzYgMjk3cS03OSAwLTE0OS0zMHQtMTIyLjUtODIuNVExNTYtMjYxIDEyNi0zMzFUOTYtNDgwcTAtODAgMzAtMTQ5LjV0ODIuNS0xMjJRMjYxLTgwNCAzMzEtODM0dDE0OS0zMHE4MCAwIDE0OS41IDMwdDEyMiA4Mi41UTgwNC02OTkgODM0LTYyOS41VDg2NC00ODBxMCA3OS0zMCAxNDl0LTgyLjUgMTIyLjVRNjk5LTE1NiA2MjkuNS0xMjZUNDgwLTk2Wm0wLTcycTEzMCAwIDIyMS05MXQ5MS0yMjFxMC0xMzAtOTEtMjIxdC0yMjEtOTFxLTEzMCAwLTIyMSA5MXQtOTEgMjIxcTAgMTMwIDkxIDIyMXQyMjEgOTFabTAtMzEyWiIvPjwvc3ZnPg==';
    return (React.createElement("div", __assign({}, containerProps, { className: classNames('ffe-tooltip', {
            'ffe-tooltip--open': isOpen,
        }) }),
        React.createElement("button", { ref: ref, "aria-expanded": isOpen, "aria-controls": children ? tooltipId : ariaControls, "aria-label": ariaLabel, className: "ffe-tooltip__icon", onClick: handleClick, type: "button", tabIndex: tabIndex, id: tooltipButtonId },
            React.createElement("span", { "aria-hidden": true },
                React.createElement(Icon, { className: "ffe-button__icon", fileUrl: helpIcon, size: "sm", ariaLabel: "?" }))),
        children && (React.createElement(Collapse, { className: "ffe-tooltip__text", id: tooltipId, isOpen: isOpen },
            React.createElement("span", { className: classNames('ffe-small-text', className), role: isOpen ? 'status' : 'none' }, children)))));
});
